<template>
  <el-dialog
    class="logistics"
    title="物流信息"
    :visible.sync="logisticsVisible"
    width="955px"
    :before-close="handleClose"
  >
    <div v-for="(t,i) in afterSalesList" :key="i" class="afterSale">
      <template v-if="t.FType !== 0">
        <p><span class="title">{{ timeTitle[t.FType] }}</span>:<span class="text">{{ t.FConfirmTime }}</span></p>
        <p><span class="title">{{ remarkTitle[t.FType] }}</span>:<span class="text">{{ t.FRemark }}</span></p>
        <p><span class="title">{{ personTitle[t.FType] }}</span>:<span class="text">{{ t.FConfirmUser }}</span></p>
        <p style="width:50%;"><span class="title">{{ imageTitle[t.FType] }}</span>:
          <span class="imgBox">
            <el-carousel v-if="t.FImagePath.length" height="90px">
              <el-carousel-item v-for="item in imageSplit(t.FImagePath)" :key="item">
                <!-- <img :src="item" alt=""> -->
                <el-image
                  style="width: 204px; height: 90px"
                  :src="item"
                  @click="previewImg(item,imageSplit(t.FImagePath))"
                />
              </el-carousel-item>
            </el-carousel>
          </span>
        </p>
      </template>
      <template v-else>
        <p><span class="title">交货时间</span>:<span class="text">{{ t.FConfirmTime }}</span></p>
        <p><span class="title">配送方式</span>:<span class="text">{{ t.FSendType ? '直发需方' : '实达实配送' }}</span></p>
        <p><span class="title">运输单号</span>:<span class="text">{{ t.FExpressNo }}</span></p>
        <p style="width:64%;"><span class="title">发货图片</span>:
          <span class="imgBox">
            <el-carousel v-if="t.FImagePath.length" height="90px">
              <el-carousel-item v-for="item in imageSplit(t.FImagePath)" :key="item">
                <!-- <img :src="item" alt=""> -->
                <el-image
                  style="width: 204px; height: 90px"
                  :src="item"
                  @click="previewImg(item,t.FImagePath)"
                />
              </el-carousel-item>
            </el-carousel>
          </span>
        </p>
        <p><span class="title">发货备注</span>:<span class="text">{{ t.FRemark }}</span></p>
      </template>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    logisticsVisible: {
      type: Boolean
    },
    afterSalesList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      timeTitle: {
        0: '发货时间',
        1: '平台收货时间',
        2: '平台发货时间',
        3: '平台代签时间',
        4: '收货时间'
      },
      remarkTitle: {
        0: '发货备注',
        1: '平台收货备注',
        2: '平台发货备注',
        3: '平台代签备注',
        4: '收货备注'
      },
      personTitle: {
        0: '发货人',
        1: '平台收货人',
        2: '平台发货人',
        3: '平台代签人',
        4: '收货人'
      },
      imageTitle: {
        0: '发货图片',
        1: '平台收货图片',
        2: '平台发货图片',
        3: '代签凭证',
        4: '收货图片'
      }
    }
  },
  watch: {

  },
  created() {

  },
  methods: {
    previewImg(src="",arr=[]){
        console.log(this,arr)
        
        this.$global_img.previewSC(src,arr,0.7)
       
    },
    imageSplit([str]) {
      console.log(str)
      if (typeof str === 'string') return str.split(';')
      return str
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss'>
    .logistics {
        .el-dialog {
            border-radius: 6px;

            .el-dialog__header {
                height: 66px;
                position: relative;
                width: 860px;
                margin: auto;
                background-color: #fff;
                border-radius: 6px 6px 0 0;

                .el-dialog__title {
                    height: 26px;
                    line-height: 26px;
                    position: absolute;
                    bottom: 0;
                    font-size: 20px;
                    color: #333;
                    font-weight: bold;
                }

                .el-dialog__headerbtn {
                    top: 45px;
                    right: 0;
                }

                .el-icon-close {
                    color: #666666;
                }
            }

            .el-dialog__body {
                padding: 30px 48px;

                .afterSale {
                    display: flex;
                    border-bottom: 1px solid #E4E4E4;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    padding-bottom: 23px;
                    margin-bottom: 14px;
                    &:last-child{
                      margin-bottom: 0;
                    }
                    p {
                        display: flex;
                        width: 32%;
                        line-height: 33px;
                        .imgBox {
                            display: inline-block;
                            min-height: 90px;
                            margin:8px 0 0 10px;
                            .el-carousel {
                                width: 204px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            >span {
                                display: inline-block;
                                height: 90px;
                                margin:8px 0 0 10px;
                            }
                        }
                    }
                    span {
                        display: inline-block;
                    }
                    .title {
                        width: 90px;
                        color: #777;
                        text-align: right;
                        // text-align: justify;
                        // text-justify: distribute-all-lines;
                        // text-align-last: justify;
                        // vertical-align: top;
                    }
                    .text {
                        width: 160px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color: #333333;
                        margin-left: 10px;
                    }
                }
            }

            .el-dialog__footer {
                padding: 10px 20px;
            }
        }
    }
</style>
